import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import LogoImg from 'assets/logos/logo.png';
import ImgBasic from 'assets/images/onboarding3.png';
import ImgComplete from 'assets/images/onboarding2.png';
import Translate from 'components/Translate';
import { ROUTE_PATH } from 'routes';
import { GA_REGISTRATION_ACTIONS, GA_REGISTRATION_LABELS } from 'constants/gaEvents';
import CmsBlocks from 'components/CmsBlocks/v2';
import { useNavigate } from 'react-router-dom';
import { SUCCESS_TYPES } from 'constants/registration';
import { useMemo } from 'react';
import useFeatureGate from 'utils/hooks/useFeatureGate';
import { FEATURE_REGISTRATION_NEW_CLIENT } from 'constants/featureGates';

const ClientSuccessMessage = ({
  literals,
  type,
  exists = false,
  customer,
  onContinue,
  onEvent,
}) => {
  const literalsKey = useMemo(() => {
    switch (type) {
      case SUCCESS_TYPES.BASIC:
        return 'successBasic';
      case SUCCESS_TYPES.BASIC_LINKED:
        return 'successBasicLinked';
      default:
        return 'successComplete';
    }
  }, [type]);
  const isBasic = type !== SUCCESS_TYPES.COMPLETE;
  // El onboarding robusto (KYC IDMission) solo existe en nativo. En navegador se
  // omite el upsell "¡Sube de nivel!" y el botón "Terminar más tarde".
  const canContinueOnboarding = useFeatureGate(FEATURE_REGISTRATION_NEW_CLIENT);
  const hideBasicUpsell = isBasic && !canContinueOnboarding;
  const navigate = useNavigate();

  const handleContinue = () => {
    if (isBasic) {
      onEvent(GA_REGISTRATION_ACTIONS.EVENT, GA_REGISTRATION_LABELS.SUCCESS_BASIC_CONTINUE);
    }
    onContinue();
  };

  const handleExit = () => {
    onEvent(GA_REGISTRATION_ACTIONS.EVENT, GA_REGISTRATION_LABELS.SUCCESS_BASIC_EXIT);
    navigate(ROUTE_PATH.HOME);
  };

  const renderDefault = (
    <div className='full-screen-container with-header'>
      <div className='screen-content'>
        <p className='font-bold text-primary mb-2 text-xl mt-4'>{literals.congratulations}</p>
        <p className='text-xl font-bold mb-6'>
          {literals[literalsKey].subtitle}
        </p>
        <img src={LogoImg} width={200} className='inline-block mb-2' alt='Platform logo' />
        <div className='flex justify-end'>
          <img height={225} src={isBasic ? ImgBasic : ImgComplete} className='inline-block mb-4' alt='Platform logo' />
        </div>
        {!hideBasicUpsell && (
          <>
            <p className='font-bold mb-4'>
              {literals[literalsKey].descriptionTitle}
            </p>
            <Translate literal={literals[literalsKey].description} vars={customer || {}} />
          </>
        )}
      </div>
      <div className='screen-actions'>
        {hideBasicUpsell ? (
          <Button onClick={handleExit}>{literals[literalsKey].finish}</Button>
        ) : (
          <>
            <Button onClick={handleContinue}>{literals[literalsKey].continue}</Button>
            {isBasic && (
              <Button
                type='outline-primary'
                onClick={handleExit}
              >
                {literals.successBasic.finishLater}
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );

  return (
    <CmsBlocks
      blockProps={{
        type,
        customer,
        exists,
        onContinue: handleContinue,
        onExit: handleExit,
      }}
      renderOnError={renderDefault}
      renderOnEmpty={renderDefault}
    />
  );
};

ClientSuccessMessage.propTypes = {
  literals: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  exists: PropTypes.bool,
  customer: PropTypes.object.isRequired,
  onContinue: PropTypes.func.isRequired,
  onEvent: PropTypes.func.isRequired,
};

export default ClientSuccessMessage;
